import React, { useState } from "react";
import MainLayout from "../../layouts/MainLayout";
import mainStyle from "../../style/Main.module.css";
import { GoFilter } from "react-icons/go";
import SearchComponent from "../../components/ui/input/Search/Search";
import Button from "../../components/ui/buttons/Button";
import { useNavigate } from "react-router-dom";
import StatusBadge from "../../components/ui/StatusBadge";
import Select from "react-select";
import PaginationComponent from "../../components/ui/Pagination/PaginationComponent";
import NoDataFound from "../../components/ui/NoDataFound/NoDataFound";
import PageLoader from "../../components/ui/Loader/PageLoader";
import { FiEdit } from "react-icons/fi";
import { statusOptions } from "../../config/selectOptions";
import { useCompanyFilter } from "../../hooks/UseFilter";
import {
  useFetchUserandrole,
  useUpdateStatusUrndRl,
} from "../../hooks/useUser&role";
import EditUserandRole from "./EditUser&Role";
import formatDate from "../../components/ui/dateFormat";
import FallbackAvatar from "../../components/ui/FallbackAvatar/FallbackAvatar";

const ViewUserAndRole = () => {
  const perPage = 10;
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;
  const [showFilter, setShowFilter] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [company, setCompany] = useState("");
  const [search, setSearch] = useState("");
  const [openEdit, setOpenEdit] = useState(false);
  // const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [datas, setDatas] = useState("");
  const [status, setStatus] = useState("");
  const [imageError, setImageError] = useState({});

  const companyFilter = useCompanyFilter();
  const {
    userAndRole: viewAccess,
    loading: isLoading,
    refresh: refreshEmployeeList,
    totalCount: totalUser,

    // Make sure your useEmployeeList hook provides this
  } = useFetchUserandrole(company, currentPage, search, perPage, status);
  const toggleFilter = () => setShowFilter((prev) => !prev);
  const { updateUserndRlStatus, loading: updateLoading } =
    useUpdateStatusUrndRl();

  const handleAllCheckboxChange = () => {
    if (isAllChecked) {
      setSelectedEmployees([]);
    } else {
      setSelectedEmployees(viewAccess.map((employee) => employee.id));
    }
    setIsAllChecked(!isAllChecked);
  };

  const handleCheckboxChange = (id) => {
    setSelectedEmployees((prevState) => {
      let newSelected;
      if (prevState.includes(id)) {
        newSelected = prevState.filter((empId) => empId !== id);
      } else {
        newSelected = [...prevState, id];
      }
      setIsAllChecked(newSelected.length === viewAccess.length);

      return newSelected;
    });
  };

  const currentPageNo = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
  };

  const handleSearch = (term) => {
    if (term !== search) {
      setSearch(term);
      setCurrentPage(1);
    }
  };

  const handleCompanyFilter = (option) => {
    if (option?.value !== company) {
      setCompany(option.value);
      setCurrentPage(1);
    }
  };

  const handleStatusUpdate = async (statusType) => {
    try {
      await updateUserndRlStatus(selectedEmployees, statusType);
      refreshEmployeeList(); // reload list
      setSelectedEmployees([]); // clear selection
      setIsAllChecked(false);
    } catch (error) {}
  };

  const handleFilterChange = (selectedOption) => {
    const newStatus = selectedOption ? selectedOption.value : "";
    if (newStatus !== status) {
      setStatus(newStatus);
      setCurrentPage(1);
    }
  };

  const addUserPage = () => {
    navigate("/userandrole/add");
  };

  const openEditPage = (datas) => {
    setDatas(datas);
    setOpenEdit(true); // Open the modal
    // setSelectedEmployee(employee); // Set the employee to be edited
  };

  const closeEditPage = () => {
    setOpenEdit(false);
    // setSelectedEmployee(null);
    refreshEmployeeList(); // Refresh the list after editing
  };

  return (
    <>
      <MainLayout>
        <div className={mainStyle.mainPageHeader}>
          {selectedEmployees.length === 0 ? (
            <>
              <div>
                <p>User And Access</p>
              </div>
              <div className={mainStyle.mainPageButtons}>
                <SearchComponent onSearch={handleSearch} />
                <Button onClick={() => navigate("/userandrole/add")}>
                  Add User Access
                </Button>
                <button
                  className={mainStyle.FilterButton}
                  onClick={toggleFilter}
                >
                  <GoFilter /> Filter
                </button>
              </div>
            </>
          ) : (
            <>
              <div></div>
              <div className={mainStyle.mainPageButtons}>
                <Button
                  variant="outline-success"
                  onClick={() => handleStatusUpdate("0")}
                  disabled={updateLoading || selectedEmployees.length === 0}
                >
                  Active
                </Button>
                <Button
                  variant="outline-danger"
                  disabled={updateLoading || selectedEmployees.length === 0}
                  onClick={() => handleStatusUpdate("1")}
                >
                  Deactive
                </Button>
              </div>
            </>
          )}
        </div>

        {showFilter && (
          <div className={mainStyle.mainPageFilter}>
            <div className={mainStyle.mainPageFilterSub}>
              <div className={mainStyle.mainPageFilterDiv}>
                <span>Company</span>
                <Select
                  className={mainStyle.pagesFilter}
                  placeholder="Select Company"
                  options={companyFilter}
                  onChange={handleCompanyFilter}
                  value={companyFilter.find(
                    (option) => option.value === company
                  )}
                />
              </div>
              <div className={mainStyle.mainPageFilterDiv}>
                <span>Status</span>
                <Select
                  className={mainStyle.pagesFilter}
                  placeholder="Action"
                  options={statusOptions}
                  onChange={handleFilterChange}
                  value={statusOptions.find(
                    (option) => option.value === status
                  )}
                />
              </div>
            </div>
          </div>
        )}

        <div
          className={mainStyle.mainContentView}
          style={{ height: showFilter ? "78%" : "92%" }}
        >
          {isLoading ? (
            <PageLoader />
          ) : (
            <div className={mainStyle.mainContentViewsb}>
              {viewAccess && viewAccess.length > 0 ? (
                <div className={mainStyle.mainTableDiv}>
                  <table className={mainStyle.mainTable}>
                    <thead className={mainStyle.mainTableHead}>
                      <tr>
                        <th>
                          <input
                            type="checkbox"
                            checked={isAllChecked}
                            onChange={handleAllCheckboxChange}
                          />
                        </th>
                        <th>User</th>
                        <th>Company</th>
                        <th>Status</th>
                        <th>Created</th>
                        <th>##</th>
                      </tr>
                    </thead>

                    <tbody className={mainStyle.mainTableBody}>
                      {viewAccess.map((emp, index) => (
                        <tr key={emp.id || index}>
                          <td>
                            <input
                              type="checkbox"
                              checked={selectedEmployees.includes(emp.id)}
                              onChange={() => handleCheckboxChange(emp.id)}
                            />
                          </td>
                          <td>
                            <div className={mainStyle.tableImgViewdiv}>
                              <div>
                                <div className={mainStyle.tableImgView}>
                                  {imageError[emp.id] &&
                                  emp.emp_pic === null ? (
                                    <FallbackAvatar
                                      name={`${emp.name}`}
                                      size={40}
                                    />
                                  ) : (
                                    <img
                                      src={`${apiUrl}${emp.emp_pic}`}
                                      alt="img"
                                      onError={() =>
                                        setImageError((prev) => ({
                                          ...prev,
                                          [emp.id]: true,
                                        }))
                                      }
                                    />
                                  )}
                                </div>
                              </div>
                              <div className={mainStyle.tableImgViewContent}>
                                <div
                                  className={mainStyle.tableImgViewContentName}
                                >
                                  {`${emp.name}`}
                                </div>
                                {/* <div
                                  className={mainStyle.tableImgViewContentEmail}
                                >
                                  {emp.email}
                                </div> */}
                              </div>
                            </div>
                          </td>
                          <td>
                            {emp.access_company &&
                              emp.access_company.length > 0 && (
                                <div
                                  className={mainStyle.companyLogosContainer}
                                >
                                  {emp.access_company
                                    .slice(0, 3)
                                    .map((company, i) => (
                                      <img
                                        key={i}
                                        src={`${apiUrl}${company.company_logo}`}
                                        alt={company.name}
                                        className={mainStyle.companyLogo}
                                      />
                                    ))}
                                  {emp.access_company.length > 3 && (
                                    <div
                                      className={
                                        mainStyle.moreCompaniesIndicator
                                      }
                                    >
                                      +{emp.access_company.length - 3}
                                    </div>
                                  )}
                                </div>
                              )}
                          </td>
                          <td>
                            <StatusBadge status={emp.access_status} />
                          </td>
                          <td>{formatDate(emp.created_date)}</td>
                          <td>
                            {emp.access_status === "0" && (
                              <FiEdit
                                onClick={() => openEditPage(emp)}
                                style={{ cursor: "pointer" }}
                              />
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <NoDataFound
                  title="No User Access Found"
                  description="No User Access found. Click the button below to add a new."
                  buttonText="Add User Access"
                  onButtonClick={addUserPage}
                />
              )}

              <div>
                {!isLoading && totalUser > perPage && (
                  <PaginationComponent
                    pageCount={Math.ceil(totalUser / perPage)}
                    onPageChange={currentPageNo}
                    forcePage={currentPage - 1}
                  />
                )}
              </div>
            </div>
          )}
        </div>

        {/* Edit Modal */}
      </MainLayout>
      {openEdit && (
        <EditUserandRole
          data={datas}
          show={openEdit}
          onClose={closeEditPage}
          // employee={selectedEmployee}
        />
      )}
    </>
  );
};

export default ViewUserAndRole;
